import React from 'react';
import './TestimonialsSection.css';

const TestimonialsSection: React.FC = () => {
  return (
    <section className="testimonials-section">
      <h2>Testimonials</h2>
      <div className="testimonials-grid">
        <div className="testimonial-item">
          <p>"CheckifAI has revolutionized our kitchen operations. The dynamic checklists ensure consistency and reduce errors, leading to happier customers and a more efficient team."</p>
          <p className="author">Sarah, Restaurant Manager</p>
        </div>
        <div className="testimonial-item">
          <p>"Since implementing CheckifAI, we've seen a significant improvement in our service quality and client satisfaction. The real-time monitoring and performance analytics are invaluable."</p>
          <p className="author">David, Cleaning Service Owner</p>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
